// import * as React from 'react';
import { sessionStorageKeys, SIGN_IN_HOST_PATH } from '../constants/general';
import { IRewardsAndOffers } from '../models/b2b';

// // Common Utilities
export const windowExists = () => typeof window !== 'undefined';

export const THD_CUSTOMER = () => {
  return typeof window !== 'undefined'
    ? window?.THDCustomer?.default
    : { role: '' };
};

export const getUserRole = () => {
  return THD_CUSTOMER()?.role || 'PURCHASER';
};

export const gatherAllParamsToString = (prefix = ''): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const entriesListStringified: string = Array.from(urlParams?.entries())
    ?.map((entry) => `${entry[0]}=${entry[1]}`)
    ?.join('&');
  if (!entriesListStringified) return '';
  return `${prefix}${entriesListStringified}`;
};

const clearSessionStorageRVData = () => {
  sessionStorage.removeItem(sessionStorageKeys.recentlyViewedItems);
  sessionStorage.removeItem(sessionStorageKeys.recentlyViewedDatestamp);
};

const redirectToLogon = (url = '') => {
  let redirectTo = '';
  const params = gatherAllParamsToString('&');

  if (url) redirectTo = `?redirect=${url}${params}`;

  clearSessionStorageRVData();

  window.location.href = `${SIGN_IN_HOST_PATH}${
    redirectTo !== '' ? redirectTo : ''
  }`;
};

export const gotoLogonModule = () => {
  const redirectTo = window.location.pathname;

  redirectToLogon(redirectTo);
};

// Safe TMX session ID retrieval
export const getTMXSessionId = () => {
  try {
    return window.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId() || '';
  } catch (error) {
    return '';
  }
};

export type MembershipLevel = 'MEMBER' | 'ELITE' | 'VIP';

export const determineMembershipLevel = (
  rewardsAndOffers: IRewardsAndOffers | null,
): MembershipLevel => {
  const tierName = rewardsAndOffers?.proTiers?.currentTierName?.toUpperCase();

  if (tierName === 'MEMBER' || tierName === 'ELITE' || tierName === 'VIP') {
    return tierName;
  }
  return 'MEMBER';
};

export const getBenefitTag = (
  rewardsAndOffers: IRewardsAndOffers | null,
  tagName?: string,
) => {
  const benefitTags = rewardsAndOffers?.proTiers?.benefitTags;
  const benefit = benefitTags?.find((tag) => tag.tagName === tagName);
  return { tag: benefit, value: benefit?.value?.toLowerCase() };
};
